import React, { Fragment, useState } from "react";
import { Redirect } from "react-router-dom";

import Header from "../components/Header";
import Menu from "../components/Menu";
import Home from "../views/Home";
import Miregistros from "../views/Miregistros";
import MiregistrosDelivery from "../views/MiregistrosDelivery";

import Productos from "../views/Productos";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: "2%",
    borderRadius: "5px",
    marginTop: "2%",
    marginBottom: " 4%",
    backgroundColor: "#FFFFFF",
    height: "auto",
    transition: "all 0.5s",
    marginRight: "1%",
    boxShadow:
      "0 4px 20px 0 rgba(0, 0, 0,.14), 0 7px 10px -5px rgba(0, 0, 0,.14)",
  },
  imgUser: {
    backgroundImage: "url(../../images/Deafult-Profile-Pitcher.png)",
    height: "50px",
    backgroundRepeat: "no-repeat",
    backgroundSize: "50px 50px",
    backgroundPosition: "center",
    marginBottom: "5%",
    marginTop: "6%",
  },
}));

export default function Dashboard() {
  const [alert] = useState({
    loggedIn: localStorage.getItem("token") === null ? false : true,
  });
  const classes = useStyles();
  const [route, setRoute] = useState("");
  const [imgUser, setImgUser] = useState(localStorage.getItem("avatarUser"));
  const [nameUser, setNameUser] = useState(localStorage.getItem("user_name"));
  const [marginLeft, setMarginLeft] = useState();

  const callbackRouta = (prop) => {
    if (prop !== "") {
      setRoute(prop);
    }
  };

  const callbackContainerLeft = (prop) => {
    if (prop !== "") {
      setMarginLeft(prop);
    }
  };

  const changeUser = (prop) => {
    if(prop[0].img !== "" && prop[2].random !== ""){
    setImgUser(prop[0].img + "?v=" + prop[2].random);

    localStorage.setItem("avatarUser", prop[0].img + "?v=" + prop[2].random);
    }else{
      setNameUser(prop[1].name);
      localStorage.setItem("user_name", prop[1].name);
    }
  };

  if (!alert.loggedIn) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <Header changeNameUser={nameUser} />
      <Menu
        callbackRouta={callbackRouta}
        changeImguser={imgUser}
        callbackContainerLeft={callbackContainerLeft}
      />
      <Grid
        item
        xs={12}
        sm={11}
        className={classes.container}
        style={{ marginLeft: marginLeft }}
      >
        {(() => {
          switch (route) {
            case "Productos":
              return <Productos />;
            case "Miregistros":
              return <Miregistros changeUserImg={changeUser} />;
            case "MiregistrosDelivery":
              return <MiregistrosDelivery changeUserImg={changeUser} />;
            default:
              return <Home callbackRoutaHome={callbackRouta} />;
          }
        })()}
      </Grid>
    </Fragment>
  );
}
